import { useProductRefreshAppShell } from './useProductRefreshAppShell'

/**
 * Gates the new settings IA experience (modal overlay, `?settings=` navigation).
 *
 * Uses the same alpha/beta rules as the app shell: alpha (`ap_rebrand_app_shell_ia`) or
 * global beta cohort, with the beta gate open. Settings ships with the shell refresh —
 * do not read `SETTINGS_IA_FLAG_KEY` directly in product code.
 */
export function useProductRefreshSettingsIa(): boolean {
  return useProductRefreshAppShell()
}
